import { useQuery, useConvexAuth } from 'convex/react';
import { api } from '../../../../backend/convex/_generated/api';

export function useWorkspaces() {
  const { isLoading: isAuthLoading } = useConvexAuth();
  const workspaces = useQuery(api.workspaces.listMyWorkspaces, isAuthLoading ? "skip" : undefined);

  return {
    workspaces: workspaces || [],
    isLoading: workspaces === undefined || isAuthLoading,
  };
}

